module.exports = __webpack_public_path__ + "img/Identification-Authentication.dc75823b.png";